import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProducersList } from './ProducersList';
import { ProducerEdit } from './ProducerEdit';
import { ProducerProducts } from './products/ProducerProducts';
import { ProductEdit } from './products/ProductEdit';

export function ProducersRouter() {
  return (
    <Routes>
      <Route index element={<ProducersList />} />
      <Route path=":id/edit" element={<ProducerEdit />} />
      <Route path=":producerId/products" element={<ProducerProducts />} />
      <Route path=":producerId/products/new" element={<ProductEdit />} />
      <Route path=":producerId/products/:id/edit" element={<ProductEdit />} />
    </Routes>
  );
} 